import { z } from "zod";

import { api } from "./api";

import type { WebProductEvent } from "@/utils/productAnalytics/client";

export const productEventsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		recordProductEvents: builder.mutation<null, readonly WebProductEvent[]>({
			// Consume failures here, before RTK emits a rejected action: the global 401 handler
			// reads storage and redirects even for mutations. Analytics must do neither.
			async queryFn(events, _api, _extraOptions, baseQuery) {
				await baseQuery({
					url: "product-events",
					method: "POST",
					body: { events },
					responseSchema: z.null(),
				});

				return { data: null };
			},
		}),
	}),
});
